var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5728 14.3105C10.2728 14.3105 7.37282 11.2105 7.07282 7.41055C6.97282 5.41055 7.57282 3.61055 8.77282 2.31055C9.97282 1.01055 11.6728 0.310547 13.5728 0.310547C15.4728 0.310547 17.1728 1.01055 18.3728 2.31055C19.5728 3.61055 20.1728 5.41055 20.0728 7.31055C19.7728 11.2105 16.8728 14.3105 13.5728 14.3105ZM13.5728 2.31055C12.2728 2.31055 11.0728 2.81055 10.2728 3.71055C9.37282 4.61055 8.97282 5.91055 9.07282 7.21055C9.27282 10.0105 11.3728 12.3105 13.5728 12.3105C15.7728 12.3105 17.8728 10.0105 18.0728 7.21055C18.1728 5.81055 17.7728 4.61055 16.8728 3.71055C16.0728 2.81055 14.8728 2.31055 13.5728 2.31055Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5728 28.3105H2.57282C1.97282 28.3105 1.47282 28.1105 1.07282 27.6105C0.672821 27.1105 0.472821 26.5105 0.672821 25.8105C1.77282 19.3105 8.17282 16.3105 13.5728 16.3105C18.9728 16.3105 25.3728 19.3105 26.5728 25.8105C26.6728 26.5105 26.5728 27.1105 26.1728 27.6105C25.6728 28.1105 25.1728 28.3105 24.5728 28.3105ZM13.5728 18.3105C8.97282 18.3105 3.57282 20.8105 2.57282 26.1105C2.57282 26.2105 2.57282 26.3105 2.57282 26.3105H24.5728C24.5728 26.3105 24.5728 26.2105 24.5728 26.1105C23.5728 20.8105 18.1728 18.3105 13.5728 18.3105Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.a2c3b83a72436d843e3960efd23bc28f.svg";
export { ForwardRef as ReactComponent };